<template>
  <dl class="checklist" :data-has-heading="heading ? true : false">
    <dt v-if="heading">{{ heading }}</dt>
    <dd>
      <ul class="checklist_items">
        <li v-for="item in items" :key="item">{{ item }}</li>
      </ul>
    </dd>
  </dl>
</template>

<script lang="ts">
export default {
  name: 'Checklist',

  props: {
    heading: String,
    items: Array
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.checklist {
  position: relative;
  padding: 9px 16px 20px;
  background-color: var.$color-secondary;

  > dt {
    font-weight: 500;
    line-height: 1;

    &::before {
      display: inline-block;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      transform: translateY(-20px);
      width: 153px;
      height: 20px;
      background-color: var.$color-secondary;
    }

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      content: '';
      transform: translate(153px, -20px);
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 20px 0 0 20px;
      border-color: transparent transparent transparent var.$color-secondary;
    }
  }

  > dd {
    margin-top: 6px;
  }

  &[data-has-heading='true'] {
    margin-top: 43px;
    padding-top: 0;
  }
}

.checklist_items {
  > li {
    text-indent: -1.4em;
    margin-left: 1.4em;

    &::before {
      display: inline-block;
      content: '';
      width: 12px;
      height: 8px;
      margin-right: 8px;
      border-left: 2px solid var.$color-main;
      border-bottom: 2px solid var.$color-main;
      transform: rotate(-45deg);
      vertical-align: 2px;
    }
  }
}
</style>
